import { Badge } from '@/components/ui/badge';
import { Tooltip, TooltipContent, TooltipTrigger } from '@/components/ui/tooltip';
import { DEFAULT_WEEKEND_BUDGET } from '@rock/tasks';
import type { TaskEffort } from '@rock/types';
import type { FC } from 'react';

/** A task type's effort in weekend points, with what the points are out of on hover. */
export const TaskEffortBadge: FC<{ effort: TaskEffort | undefined }> = ({ effort }) => {
    const { effortPerWeekend, effort: defaults } = DEFAULT_WEEKEND_BUDGET;
    return (
        <Tooltip>
            <TooltipTrigger asChild>
                <Badge variant={effort ? 'secondary' : 'outline'} className="cursor-help">
                    {effort ? pointsLabel(effort) : 'Not Set'}
                </Badge>
            </TooltipTrigger>
            <TooltipContent className="max-w-[280px] leading-snug">
                {effort
                    ? `Takes ${pointsLabel(effort)} of the ${effortPerWeekend} a weekend has.`
                    : `No effort set, so it is priced as ${pointsLabel(defaults.actions)} of the ${effortPerWeekend} a weekend has.`}
            </TooltipContent>
        </Tooltip>
    );
};

function pointsLabel(points: number): string {
    return points === 1 ? '1 point' : `${points} points`;
}
